import { render, staticRenderFns } from "./LeadNotifications.vue?vue&type=template&id=39469587&scoped=true&"
import script from "./LeadNotifications.vue?vue&type=script&lang=js&"
export * from "./LeadNotifications.vue?vue&type=script&lang=js&"
import style0 from "./LeadNotifications.vue?vue&type=style&index=0&id=39469587&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39469587",
  null
  
)

export default component.exports